module.exports = __webpack_public_path__ + "static/017-09426ee7fd4f60e3438404284c642160.jpg";